import { Service } from '@angular/core';

@Service()
export class ComparatorService 
{
  compareById(o1: any, o2: any)
  {
    if (o1 == null || o2 == null) {
        return false;
    } else {
        return o1.id == o2.id;
    }
  }

  compareByDescription(o1: any, o2: any)
  {
      if (o1 == null || o2 == null) {
          return false;
      } else {
          return o1.description == o2.description;
      }
  }

  compareByBoolean(o1: boolean, o2: boolean)
  {
      if (o1 == null || o2 == null) {
          return false;
      } else {
          return o1 == o2;
      }
  }

  compareByNumber(o1: number, o2: number)
  {
      if (o1 == null || o2 == null) {
          return false;
      } else {
          return o1 == o2;
      }
  }
}
